import Commons from '../../../../Services/Common/Common';

/**
 * BUD_BASIC_02 스키마
 * - fields: 폼/그리드에서 공통으로 쓰는 필드 정의
 *   - initial: 초기값
 *   - label: 필드명
 *   - required: 필수 입력 여부
 *   - requiredWhen: 언제 필수인지 조건
 *
 * - mapper: 저장 API payload 생성 규칙
 *   - mapRowsBySchema(rows, mapper, context)로 payload를 만듬
 *   - context에는 userInfo 등이 들어오며(mapRowsBySchema에 기본족으로 정의되어 있음),
 *     화면에서 추가로 필요한 값(custCd 등)을 context로 넘겨줄 수 있다.
 */
export const BUD_BASIC_02_Schema = {
  fields: {
    no: { initial: '', label: 'NO' },
    budCd: { initial: '', label: '예산코드' },
    categoryId: { initial: '', label: '구분ID' },
    categoryName: { initial: '', label: '구분', required: 'Y' },
    itemId: { initial: '', label: '구분상세ID' },
    itemName: { initial: '', label: '구분상세', required: 'Y' },
    prevYearAmount: { initial: 0, label: '예산 편성 금액' },
    prevExecAmount: { initial: 0, label: '집행내역' },
    prevExecRate: { initial: 0, label: '집행율' },
    month01: { initial: 0, label: '1월' },
    month02: { initial: 0, label: '2월' },
    month03: { initial: 0, label: '3월' },
    month04: { initial: 0, label: '4월' },
    month05: { initial: 0, label: '5월' },
    month06: { initial: 0, label: '6월' },
    month07: { initial: 0, label: '7월' },
    month08: { initial: 0, label: '8월' },
    month09: { initial: 0, label: '9월' },
    month10: { initial: 0, label: '10월' },
    month11: { initial: 0, label: '11월' },
    month12: { initial: 0, label: '12월' },
    totalYearAmount: { initial: 0, label: '예산총액' },
    remark: { initial: '', label: '비고' },
    isSummaryRow: { initial: false, label: '합계 행 여부' },
  },

  mapper: {
    search1: {
      CustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd || '') || '',
      BudYear: (_, context) =>
        Commons.EncryptAES(context.search?.year || '') || '',
      BudType: (_, context) => Commons.EncryptAES('0') || '',
      UserId: (_, context) => context.userInfo?.userid || '',
    },

    // 구분상세 삭제
    delete1: {
      ItemId: (row) =>
        Commons.EncryptAES(
          (row.itemId ? parseInt(row.itemId) || 0 : 0).toString()
        ) || '',
      BudYear: (_, context) =>
        Commons.EncryptAES(context.search?.year || '') || '',
    },

    save1: {
      BudYear: (_, context) =>
        Commons.EncryptAES(context.search?.year || '') || '',
      ItemId: (row) =>
        Commons.EncryptAES(
          (row.itemId ? parseInt(row.itemId) || 0 : 0).toString()
        ) || '',
      CategoryName: (row) =>
        Commons.EncryptAES(row.categoryName || '') || '',
      ItemName: (row) =>
        Commons.EncryptAES(row.itemName || '') || '',
      Month01: (row) =>
        Commons.EncryptAES(
          (row.month01 ? parseFloat(row.month01) : 0).toString()
        ) || '',
      Month02: (row) =>
        Commons.EncryptAES(
          (row.month02 ? parseFloat(row.month02) : 0).toString()
        ) || '',
      Month03: (row) =>
        Commons.EncryptAES(
          (row.month03 ? parseFloat(row.month03) : 0).toString()
        ) || '',
      Month04: (row) =>
        Commons.EncryptAES(
          (row.month04 ? parseFloat(row.month04) : 0).toString()
        ) || '',
      Month05: (row) =>
        Commons.EncryptAES(
          (row.month05 ? parseFloat(row.month05) : 0).toString()
        ) || '',
      Month06: (row) =>
        Commons.EncryptAES(
          (row.month06 ? parseFloat(row.month06) : 0).toString()
        ) || '',
      Month07: (row) =>
        Commons.EncryptAES(
          (row.month07 ? parseFloat(row.month07) : 0).toString()
        ) || '',
      Month08: (row) =>
        Commons.EncryptAES(
          (row.month08 ? parseFloat(row.month08) : 0).toString()
        ) || '',
      Month09: (row) =>
        Commons.EncryptAES(
          (row.month09 ? parseFloat(row.month09) : 0).toString()
        ) || '',
      Month10: (row) =>
        Commons.EncryptAES(
          (row.month10 ? parseFloat(row.month10) : 0).toString()
        ) || '',
      Month11: (row) =>
        Commons.EncryptAES(
          (row.month11 ? parseFloat(row.month11) : 0).toString()
        ) || '',
      Month12: (row) =>
        Commons.EncryptAES(
          (row.month12 ? parseFloat(row.month12) : 0).toString()
        ) || '',
      Remark: (row) => Commons.EncryptAES(row.remark || '') || '',
      CustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd || '') || '',
      BudType: (_, context) => Commons.EncryptAES('0') || '',
      UserId: (_, context) => context.userInfo?.userid || '',
    },
  },
};
